import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const AccessDenied = ({ message }) => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#fee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px'
      }}>
        <FontAwesomeIcon 
          icon={faExclamationTriangle} 
          style={{ 
            fontSize: '36px', 
            color: '#d32f2f' 
          }} 
        />
      </div>

      <h2 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#333',
        marginBottom: '12px'
      }}>
        Acesso negado
      </h2>

      <p style={{
        fontSize: '16px',
        color: '#666',
        marginBottom: '32px',
        maxWidth: '400px'
      }}>
        {message || 'Você não tem permissão para acessar esta página.'}
      </p>

      <button
        onClick={() => navigate(-1)}
        style={{
          padding: '12px 32px',
          backgroundColor: '#6366f1',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'background-color 0.2s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#4f46e5'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#6366f1'}
      >
        Voltar
      </button>
    </div>
  );
};

export default AccessDenied;
